import React from 'react';

const ClassLanguage: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = props => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2127_6949)">
      <path
        d="M20.5 10.5H11.5C10.9477 10.5 10.5 10.9477 10.5 11.5V20.5C10.5 21.0523 10.9477 21.5 11.5 21.5H20.5C21.0523 21.5 21.5 21.0523 21.5 20.5V15.5V11.5C21.5 10.9477 21.0523 10.5 20.5 10.5Z"
        stroke="#5A6474"
        strokeLinecap="round"
      />
      <path
        d="M13.5 8.5V3.5C13.5 2.94772 13.0523 2.5 12.5 2.5H8H3.5C2.94772 2.5 2.5 2.94772 2.5 3.5V8V12.5C2.5 13.0523 2.94772 13.5 3.5 13.5H8.5"
        stroke="#5A6474"
        strokeLinecap="round"
      />
      <path
        d="M5 11L8 5L10 9"
        stroke="#5A6474"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6 9H10" stroke="#5A6474" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M15 13L17.5 12.5"
        stroke="#5A6474"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 17.25C18 18.6307 17.3807 19.5 16 19.5C14.6193 19.5 14 18.6307 14 17.25C14 15.8693 14.6193 15 16 15C17.3807 15 18 15.8693 18 17.25Z"
        stroke="#5A6474"
      />
    </g>
    <defs>
      <clipPath id="clip0_2127_6949">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default ClassLanguage;
